module.exports = __webpack_public_path__ + "img/va.cd221df8.png";